import PropTypes from 'prop-types';
import { useMemo } from 'react';

import useClientSide from 'hooks/useClientSide';
import useMediaQuery from 'hooks/useMediaQuery';

import { pixealize } from 'lib/utils';

import { useTopbar } from 'providers/TopbarProvider';

const SPACE_BETWEEN_SIDEBAR_COMPONENTS_PX = 24;

const Sidebar = ({ children, refsToBeIgnoredBeforeFixing = [] }) => {
  const { isXl } = useMediaQuery();
  const isClientSide = useClientSide();
  const {
    topbarDesktop: {
      constants: { topbarMainHeight, topbarBottomHeight },
    },
  } = useTopbar();

  const offsetTop = useMemo(() => {
    if (!isXl || !isClientSide || refsToBeIgnoredBeforeFixing.length === 0) {
      return 0;
    }

    let elemsTotalHeight = 0;

    for (const { current: elem } of refsToBeIgnoredBeforeFixing) {
      if (!elem || elem?.retry) {
        continue;
      }

      elemsTotalHeight += elem?.offsetHeight;
    }
    const gap =
      (refsToBeIgnoredBeforeFixing.length - 1) *
      SPACE_BETWEEN_SIDEBAR_COMPONENTS_PX;

    return topbarMainHeight + topbarBottomHeight - elemsTotalHeight - gap;
  }, [isXl, topbarMainHeight, topbarBottomHeight, isClientSide]);

  return (
    <aside
      className="peer sticky flex h-auto w-full flex-col gap-y-6 px-4 lg:col-span-4 lg:col-start-13 lg:max-w-80 lg:px-0 xl:h-fit"
      style={{ top: pixealize(offsetTop) }}
      data-sidebar
    >
      {children}
    </aside>
  );
};

Sidebar.propTypes = {
  children: PropTypes.node.isRequired,
  refsToBeIgnoredBeforeFixing: PropTypes.arrayOf(PropTypes.shape()),
};

export default Sidebar;
